import qs from 'qs';
import apiService from '../helpers/StrapiClientHelper';
import { ALL_CATEGORIES } from '../configs/commons';

export const getBlogCategories = async () => {
    const blogTags = apiService.collection('blog-categories');
    const res = await blogTags.find({
        sort: 'categoryName:asc',
        pagination: {
            limit: 100
        }
    })
    return res.data
};

export const getLatestBlogs = async (limit: number) => {
    const res = await apiService.fetch(`/blogs/latest?limit=${limit}`);
    const json = await res.json();
    return json.data;
};

export const getBlogsByCategory = async (category: string, paging: any) => {
    const query = qs.stringify({
        pagination: {
            page: paging.page,
            pageSize: paging.pageSize,
        }
    }, { encodeValuesOnly: true });
    let endpoint = `/blogs?${query}`;
    if (!!category && category !== ALL_CATEGORIES) {
        endpoint = `/blogs/category/${category}?${query}`;
    }
    const res = await apiService.fetch(endpoint);
    const data = await res.json();
    return data;
}

export const getBlogsGenerateSitemap = async () => {
    const query = qs.stringify({
        pagination: {
            page: 1,
            pageSize: 10000,
        }
    }, { encodeValuesOnly: true });
    let endpoint = `/blogs?${query}`;
    const res = await apiService.fetch(endpoint);
    const data = await res.json();
    return data;
}

export const getBlogsByGroupCategoryAPI = async (groupCategoryName: string, paging: any) => {
    const query = qs.stringify({
        pagination: {
            page: paging.page,
            pageSize: paging.pageSize,
        }
    }, { encodeValuesOnly: true });

    let endpoint = `/blogs/group-category/${groupCategoryName}?${query}`;

    const res = await apiService.fetch(endpoint);
    const data = await res.json();
    return data;
}

export const getBlogBySlug = async (slug: string) => {
    const blogs = apiService.collection('blogs');
    const res = await blogs.findOne(slug, {
        populate: {
            defaultSeo: {
                populate: {
                    shareImage: {
                        populate: '*'
                    }
                }
            },
            coverImage: { populate: '*' },
            authors: { populate: { avatar: { populate: '*' } } },
            categories: true,
            content: { populate: '*' },
            blogRelated: { populate: '*' }
        }
    });

    return res.data;
}